import { Box, Tab, Tabs, Typography } from '@mui/material';
import React from 'react'
import EditarCadastroModelo from './CadastroModelo/EditarCadastroModelo';
import { useParams } from 'react-router';
import { useCadastroModelo } from '../../hooks/useCadastroModelo';
import ListaCadastroModelos from './CadastroModelo/ListaCadastroModelos';
import CriarModeloAgendamento from './Agendamento/CriarModeloAgendamento';
import { ModeloAgendamento } from '../../interface/IAgendamento';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      tabIndex={0}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function FluxoTabs() {
  const { companyId, id } = useParams<{ companyId: string; id: string }>();
  const cadastroModelos = useCadastroModelo(companyId, id);
  const agendamentos = useCadastroModelo(companyId, undefined, 'agendamento');
  const [value, setValue] = React.useState(0);
  const [criandoModeloAgendamento, setCriandoModeloAgendamento] = React.useState(false);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = React.useState<ModeloAgendamento | undefined>();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    if (id) {
      window.scrollTo(0, 0);
    }
  }, [id]);
  const title = id ? id === 'novo' ? 'Criar Cadastro-Modelo' : 'Editar Cadastro-Modelo' : 'Cadastros-Modelo';
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='secondary'
            variant="scrollable"
            scrollButtons="auto">
            <Tab label="Modelos" {...a11yProps(0)} />
            <Tab label="Modelos de Agendamento" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <Typography
            variant='h5'
            fontWeight={600}
            color='textDisabled'
            textAlign='center'
            width='100%' >
            {title}
          </Typography>
          {id && companyId
            ? <EditarCadastroModelo cadastroModelos={cadastroModelos} companyId={companyId} id={id} />
            : <ListaCadastroModelos companyId={companyId} cadastroModelos={cadastroModelos} />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Typography
            variant='h5'
            fontWeight={600}
            color='textDisabled'
            textAlign='center'
            width='100%' >
            Modelos de Agendamento
          </Typography>
          {criandoModeloAgendamento
            ? <CriarModeloAgendamento
              modelos={Array.isArray(cadastroModelos.data) ? cadastroModelos.data : []}
              onBack={() => { setCriandoModeloAgendamento(false); setAgendamentoSelecionado(undefined); }}
              onSave={async (agendamento) => {
                if (agendamentoSelecionado?.id) {
                  await agendamentos.updateAgendamentoAsync({ id: agendamentoSelecionado.id, agendamento });
                } else {
                  await agendamentos.createAgendamentoAsync(agendamento);
                }
                setCriandoModeloAgendamento(false);
                setAgendamentoSelecionado(undefined);
              }}
              saving={agendamentos.loadingCreateAgendamento || agendamentos.loadingUpdateAgendamento}
              agendamento={agendamentoSelecionado}
            />
            : <ListaCadastroModelos
              companyId={companyId}
              cadastroModelos={agendamentos}
              onCreate={() => { setAgendamentoSelecionado(undefined); setCriandoModeloAgendamento(true); }}
              onItemClick={(agendamento: any) => { setAgendamentoSelecionado(agendamento as ModeloAgendamento); setCriandoModeloAgendamento(true); }}
              onDuplicate={(agendamento: any) => agendamentos.duplicateAgendamento(agendamento as ModeloAgendamento)}
              inactivateModelo={agendamentos.inactivateAgendamento}
              deleteLabel='Inativar'
              textos={{
                botaoNovo: 'Criar novo Agendamento',
                busca: 'Buscar modelos de agendamento',
                descricaoVazia: 'Esta empresa ainda não possui modelos de agendamento.',
                erro: 'Erro ao buscar modelos de agendamento',
                instrucaoSemEmpresa: 'Selecione uma empresa para visualizar os modelos de agendamento',
              }}
            />}
        </CustomTabPanel>
      </Box>
    </>
  )
}
